import React, { useEffect, useState } from "react";
import { TableContainer, Paper, Button } from "@mui/material";
import { Link } from "react-router-dom";

// material-ui
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

import ImportExcel from "../../../components/Imports/ImportExcel";
import SimpleTableHeader from "../../../components/Tables/SimpleTableHeader";
import DisplayExport from "../../../components/Exports/DisplayExport";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
import { Post_To_MongoDB_No_PopUp } from "../../../api/Post_To_MongoDB_No_PopUp";
// material-ui

function ImportTCSCertificates() {
  const { logout } = StaffuseAuth();

  const [Arr_TCS, setArr_TCS] = useState([]);

  let Arr_PropsToSee = [
    "Email",
    "Name",
    "Distinction",
    "Note",
    "Notes",
    "Group",
    "School",
    "Score",
    "Strength",
    "Weak",
    "EmailCC",
  ];

  let Arr_PropsToSee_TemplateExport = [
    {
      Email: "Insert",
      Name: "Insert",
      Distinction: "Insert",
      Note: "Insert",
      Notes: "Insert",
      Group: "Insert",
      School: "Insert",
      Score: "Insert",
      Strength: "Insert",
      Weak: "Insert",
      EmailCC: "Insert",
    },
    {
      Email: "Creativity",
      Name: "Teamwork",
      Distinction: "Leadership",
      Note: "Prioritisation",
      Notes: "Communication",
      Group: "Analytical Thinking",
      School: "Public Speaking",
      Score: "...",
      Strength: "...",
      Weak: "...",
      EmailCC: "...",
    },
  ];

  const [UploadStatus, setUploadStatus] = useState(false);
  console.log("Arr_TCS");
  console.log(Arr_TCS);

  function handleUploadData(e) {
    let updatedArr_TCS = [...Arr_TCS];
    //change all prop titles of Invoice Date to Invoice_Date in updatedArr_TCS
    // updatedArr_TCS.forEach((student) => {
    //   //
    //   student.Email = student["Email"];
    //   delete student["Email"];
    //   //
    // });
    //Loop thro Arr_TCS and uplaod each to mongoDB
    updatedArr_TCS.forEach((student) => {
      Post_To_MongoDB_No_PopUp(
        student,
        "Emails",
        "TCS",
        setUploadStatus,
        logout
      );
    });
  }

  return (
    <div
      style={{
        backgroundColor: "#e5e5e5",
        minHeight: "93vh",
        paddingLeft: "10px",
      }}
    >
      <section>
        <h1 style={{ marginTop: "0px" }}>Import TCS</h1>
        <p>
          First, get the Template from the 'Export'. Make sure you put your data
          into this spreadsheet EXACTLY. Make sure to put Yes and No instead of
          Y and N. Import , then click "Upload to Database". Wait for approx 10
          seconds. you can now close this tab. Head to the sending area and use
          the filter to check it has worked. Contact Curtis for any and all
          support. Options are to be spelt "Creativity" "Teamwork" "Leadership"
          "Prioritisation" "Communication" "Analytical Thinking" "Public
          Speaking"{" "}
        </p>
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <h2>View All TCS</h2>
          <ImportExcel setImportData={setArr_TCS} />
          Get Template:
          <DisplayExport
            excelData={Arr_PropsToSee_TemplateExport}
            fileName={"TCS_Import_Template"}
          />
          <button
            style={{ maxWidth: "5%", maxHeight: "100px" }}
            onClick={(e) => handleUploadData(e)}
          >
            Upload to the Database
          </button>
        </div>

        <section>
          <TableContainer
            component={Paper}
            sx={{
              width: "100%",
              margin: "0 auto",
              overflow: "auto",
            }}
          >
            <Table
              aria-label="simple table"
              sx={{
                border: "1px solid #e0e0e0",
                tableLayout: "fixed",
              }}
            >
              <TableHead>
                <TableRow>
                  {Arr_PropsToSee && Array.isArray(Arr_PropsToSee) ? (
                    Arr_PropsToSee.map((Prop, Prop_index) =>
                      SimpleTableHeader(Prop)
                    )
                  ) : (
                    <></>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow style={{ border: "1px solid black" }}></TableRow>

                {Arr_TCS && Array.isArray(Arr_TCS) ? (
                  Arr_TCS.map((Obj_Transaction, Obj_Transaction_index) => (
                    <>
                      <TableRow
                        key={Obj_Transaction_index}
                        sx={{
                          "&:hover": {
                            backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                            "& .MuiTableCell-root": {
                              padding: "8px",
                              wordWrap: "break-word",
                              overflowWrap: "break-word", // Adjust padding here to make cells smaller
                            },
                          },
                        }}
                      >
                        {Arr_PropsToSee && Array.isArray(Arr_PropsToSee) ? (
                          Arr_PropsToSee.map((Prop, Prop_index) => (
                            <TableCell
                              component="th"
                              scope="row"
                              sx={{
                                padding: "8px",
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                              }}
                            >
                              {Obj_Transaction[Prop]}
                            </TableCell>
                          ))
                        ) : (
                          <></>
                        )}
                      </TableRow>
                    </>
                  ))
                ) : (
                  <></>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </section>
      </section>
    </div>
  );
}

export default ImportTCSCertificates;
